import React from 'react';

class HomeCameraProPlus extends React.Component {
  render() {
    return (
      <svg
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M55.9281 26.538C55.9281 32.56 53.2401 37.958 48.9941 41.584H23.2601C19.0201 37.956 16.3301 32.56 16.3301 26.538C16.3301 15.606 25.1921 6.73999 36.1281 6.73999C47.0641 6.73999 55.9261 15.606 55.9261 26.538H55.9281Z"
          fill="#F7F4F1"
        />
        <path
          d="M36.128 36.8339C42.2506 36.8339 47.214 31.8705 47.214 25.7479C47.214 19.6252 42.2506 14.6619 36.128 14.6619C30.0054 14.6619 25.042 19.6252 25.042 25.7479C25.042 31.8705 30.0054 36.8339 36.128 36.8339Z"
          fill="url(#paint0_linear_248_1362)"
        />
        <path
          d="M60.6244 73.26L61.8124 70.276C61.8124 59.324 57.1524 48.89 48.9944 41.582H23.2604C15.1044 48.89 10.4424 59.324 10.4424 70.276L11.6304 73.26H60.6224H60.6244Z"
          fill="#F7F4F1"
        />
        <path
          d="M62.5503 70.2778C62.5503 59.9158 58.4323 49.9758 51.1843 42.6518L51.1803 42.6478C51.1803 42.6478 51.1683 42.6358 51.1623 42.6298C51.0483 42.5158 50.9343 42.4018 50.8183 42.2878C50.6543 42.1278 50.4923 41.9678 50.3283 41.8118C50.2623 41.7498 50.1963 41.6878 50.1283 41.6238L50.0923 41.5898C52.2263 39.6118 53.8943 37.2278 55.0143 34.6058C55.0143 34.6018 55.0183 34.5978 55.0203 34.5938C55.8883 32.5618 56.4123 30.4318 56.5923 28.2398C56.5923 28.2298 56.5923 28.2178 56.5943 28.2078C56.6063 28.0458 56.6183 27.8838 56.6283 27.7218C56.6283 27.6958 56.6323 27.6678 56.6343 27.6418C56.6423 27.4938 56.6483 27.3438 56.6523 27.1938C56.6523 27.1578 56.6563 27.1198 56.6563 27.0838C56.6603 26.9038 56.6643 26.7238 56.6643 26.5438V26.5338C56.6643 23.7438 56.1123 21.0318 55.0203 18.4738C55.0123 18.4538 55.0003 18.4358 54.9903 18.4158C51.8383 11.1178 44.5703 5.99585 36.1263 5.99585C27.6823 5.99585 20.4163 11.1178 17.2623 18.4158C17.2523 18.4358 17.2403 18.4518 17.2323 18.4738C16.1423 21.0218 15.5883 23.7338 15.5883 26.5338V26.5438C15.5883 26.7238 15.5903 26.9038 15.5963 27.0838C15.5963 27.1198 15.5983 27.1558 15.6003 27.1918C15.6043 27.3418 15.6103 27.4918 15.6183 27.6418C15.6183 27.6678 15.6223 27.6938 15.6223 27.7198C15.6323 27.8818 15.6423 28.0438 15.6563 28.2058C15.6563 28.2158 15.6563 28.2278 15.6583 28.2378C15.8383 30.4298 16.3643 32.5618 17.2303 34.5918C17.2303 34.5938 17.2343 34.5978 17.2343 34.5998C18.3543 37.2238 20.0203 39.6078 22.1543 41.5878L22.1183 41.6218C22.0523 41.6838 21.9843 41.7458 21.9183 41.8098C21.7563 41.9658 21.5923 42.1238 21.4283 42.2838C21.3123 42.3978 21.1983 42.5118 21.0843 42.6258C21.0783 42.6318 21.0723 42.6378 21.0663 42.6438L21.0623 42.6478C13.8143 49.9718 9.69629 59.9118 9.69629 70.2738C9.69629 70.3678 9.71429 70.4598 9.74829 70.5478L10.3043 71.9458L10.9343 73.5298C11.0463 73.8118 11.3183 73.9958 11.6203 73.9958H60.6123C60.9143 73.9958 61.1863 73.8118 61.2983 73.5298L61.9283 71.9458L62.4843 70.5458C62.5183 70.4598 62.5363 70.3658 62.5363 70.2718L62.5503 70.2778ZM18.6543 34.1478V18.9338C21.5963 12.1978 28.3223 7.47785 36.1303 7.47785C43.9383 7.47785 50.6643 12.1978 53.6063 18.9338V34.1458C52.5023 36.6818 50.8463 38.9738 48.7203 40.8438H23.5363C21.4123 38.9738 19.7583 36.6818 18.6543 34.1458V34.1478ZM21.9103 43.9078H50.3463C57.1583 50.9018 61.0363 60.3158 61.0723 70.1378L60.7523 70.9398H11.5023L11.1823 70.1378C11.2183 60.3178 15.0963 50.9018 21.9083 43.9078H21.9103Z"
          fill="#83827F"
        />
        <path
          d="M36.128 31.2919C39.1899 31.2919 41.672 28.8097 41.672 25.7479C41.672 22.686 39.1899 20.2039 36.128 20.2039C33.0661 20.2039 30.584 22.686 30.584 25.7479C30.584 28.8097 33.0661 31.2919 36.128 31.2919Z"
          fill="white"
        />
        <path
          d="M36.128 28.9158C37.8776 28.9158 39.296 27.4975 39.296 25.7478C39.296 23.9982 37.8776 22.5798 36.128 22.5798C34.3783 22.5798 32.96 23.9982 32.96 25.7478C32.96 27.4975 34.3783 28.9158 36.128 28.9158Z"
          fill="url(#paint1_linear_248_1362)"
        />
        <path
          d="M70.1285 10.6H65.5285V6H62.3285V10.6H57.7285V13.8H62.3285V18.4H65.5285V13.8H70.1285V10.6Z"
          fill="url(#paint2_linear_248_1362)"
        />
        <path
          d="M65.5287 19.2H62.3287C61.8867 19.2 61.5287 18.842 61.5287 18.4V14.6H57.7287C57.2867 14.6 56.9287 14.242 56.9287 13.8V10.6C56.9287 10.158 57.2867 9.79995 57.7287 9.79995H61.5287V5.99995C61.5287 5.55795 61.8867 5.19995 62.3287 5.19995H65.5287C65.9707 5.19995 66.3287 5.55795 66.3287 5.99995V9.79995H70.1287C70.5707 9.79995 70.9287 10.158 70.9287 10.6V13.8C70.9287 14.242 70.5707 14.6 70.1287 14.6H66.3287V18.4C66.3287 18.842 65.9707 19.2 65.5287 19.2ZM63.1287 17.6H64.7287V13.8C64.7287 13.358 65.0867 13 65.5287 13H69.3287V11.4H65.5287C65.0867 11.4 64.7287 11.042 64.7287 10.6V6.79995H63.1287V10.6C63.1287 11.042 62.7707 11.4 62.3287 11.4H58.5287V13H62.3287C62.7707 13 63.1287 13.358 63.1287 13.8V17.6Z"
          fill="#84827E"
        />
        <defs>
          <linearGradient
            id="paint0_linear_248_1362"
            x1="28.1605"
            y1="16.645"
            x2="43.211"
            y2="33.9088"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_248_1362"
            x1="33.8511"
            y1="23.1465"
            x2="38.152"
            y2="28.0799"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_248_1362"
            x1="59.4726"
            y1="7.10908"
            x2="67.8898"
            y2="16.7641"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
        </defs>
      </svg>
    );
  }
}

export default HomeCameraProPlus;
